export const validFileTypes: string[] = [
  'png',
  'pdf',
  'jpg',
  'jpeg',
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'doc',
  'docx',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const isValidFileType = (fileType: string): boolean => {
  return validFileTypes.some((type) => fileType.includes(type));
};

export const validFileTypesAdjustmentAid: string[] = [
  'xlsx',
  'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
